import React, { useState } from "react";
import usePageMeta from "../../hooks/usePageMeta"; // 1. Import hook
import "./PortfolioPage.css";
import portfolioData from "../../utils/portfolioData.json";
import AlbumCard from "../AlbumCard/AlbumCard";

const categories = [
  "All",
  "Lacrosse",
  "Football",
  "Soccer",
  "Hockey",
  "Basketball",
  "Baseball",
  "Wrestling",
  "Volleyball",
  "Cross Country",
  "Events",
  "Portraits",
  "Other",
];

function PortfolioPage() {
  // 2. Set page title and description
  usePageMeta(
    "Portfolio | TjWit Media",
    "Explore a diverse portfolio of sports, events, and portrait photography. Filter by category to see the latest work.",
  );

  const [activeFilter, setActiveFilter] = useState("All");
  const validAlbums = portfolioData.filter(
    (album) => album.link && album.previewImage && album.category,
  );
  const filteredAlbums =
    activeFilter === "All"
      ? validAlbums
      : validAlbums.filter((album) => album.category === activeFilter);

  return (
    <div className="portfolio-container">
      <header className="portfolio-header">
        <h1>PORTFOLIO</h1>
        <p>Explore my most recent work! Click on an album to view more.</p>
      </header>
      <div className="filter-buttons">
        {categories.map((category) => (
          <button
            key={category}
            className={`filter-button ${
              activeFilter === category ? "active" : ""
            }`}
            onClick={() => setActiveFilter(category)}
          >
            {" "}
            {category}{" "}
          </button>
        ))}
      </div>
      <div className="portfolio-grid">
        {filteredAlbums.map((album, index) => (
          <AlbumCard
            key={album.name}
            name={album.name}
            previewImage={album.previewImage}
            link={album.link}
            delay={`${index * 100}ms`}
          />
        ))}
      </div>
    </div>
  );
}
export default PortfolioPage;
